// extracted by mini-css-extract-plugin
export default {"root":"RegularEventDetailsModal_root__Ldp63","label":"RegularEventDetailsModal_label__cLsC8","footer":"RegularEventDetailsModal_footer__GkCLg"};